export type PerformanceRatioStatus = "bad" | "good";

export const PERFORMANCE_RATIO_THRESHOLD = 3.5;

export const PERFORMANCE_RATIO_STATUS_STYLES: Record<
  PerformanceRatioStatus,
  { markerClassName: string; textClassName: string; trackClassName: string }
> = {
  bad: {
    markerClassName: "bg-lds-purpose-status-negative",
    textClassName: "text-lds-purpose-status-negative",
    trackClassName: "bg-lds-purpose-status-negative",
  },
  good: {
    markerClassName: "bg-lds-purpose-status-positive",
    textClassName: "text-lds-purpose-status-positive",
    trackClassName: "bg-lds-purpose-status-positive",
  },
};

export const getPerformanceRatioStatus = (label?: null | string | undefined): PerformanceRatioStatus =>
  label ? "bad" : "good";

export const getGaugeScaleMax = (ratio: number, threshold: number): number => Math.max(threshold * 2, ratio * 1.1);

export const getGaugePositionPercent = (value: number, scaleMax: number): number =>
  Math.min(100, Math.max(0, (value / scaleMax) * 100));
